const STATE_WHITELIST = [
  'navStack',
  'email',
  'countryCode',
  'deviceEmei',
  'deviceModel',
  'selectedPlanId',
  'selectedPlanInterval',
  'devicePlatform',
  'validatedPromoCode',
  'vineEnabled',
  'isAmazonReviewer',
];

export const encodeActivationState = (state) => {
  const serializableState = Object.fromEntries(
    Object.entries(state).filter(([key]) => STATE_WHITELIST.includes(key)),
  );

  return window.btoa(JSON.stringify(serializableState));
};

export const decodeActivationState = (encodedState) => {
  const state = JSON.parse(window.atob(encodedState));

  // Checkout URLs issued before selectedPlanId was introduced contain a plan object.
  if (state.selectedPlanId == null && state.selectedPlan) {
    state.selectedPlanId = state.selectedPlan.id;
  }
  delete state.selectedPlan;

  return state;
};
